module.exports = __webpack_public_path__ + "static/logo-132a6a3e50b1cae90e90f0d72c39f5fa.svg";